export const SCHOOLS = {
  ink: '#08081B',
  muted: '#63637D',
  surface: '#F6F6F8',
  cardBg: '#FFFFFF',
  border: 'rgba(8, 8, 27, 0.15)',
  ghost: '#2A2A8B',
  emphasis: '#512100',
  compareInk: '#505071',
  positiveChipBg: '#E3F4DF',
  positiveChipFg: '#132B0D',
  thresholdRule: '#B74A01',
  approachingBar: '#FEC620',
  ltelBar: '#FB7B04',
  alertBg: '#FEEAD7',
  alertDetail: '#843501',
  cardShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  font: '"Nunito Sans", "Helvetica", "Arial", sans-serif',
  columns: { school: 256, students: 96, newcomers: 112, ltels: 96 },
} as const;
